import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { FaUser, FaMapMarkedAlt } from 'react-icons/fa';

const Profile = () => {
  const { user } = useContext(AuthContext);
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: { street: '', city: '', state: '', zipCode: '', country: '' },
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        email: user.email || '',
        phone: user.phone || '',
        address: {
          street: user.address?.street || '',
          city: user.address?.city || '',
          state: user.address?.state || '',
          zipCode: user.address?.zipCode || '',
          country: user.address?.country || '',
        },
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('address.')) {
      const k = name.split('.')[1];
      setFormData({ ...formData, address: { ...formData.address, [k]: value } });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`/api/users/${user._id}/profile`, formData);
      toast.success('Profile updated successfully');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update profile');
    } finally {
      setSaving(false);
    }
  };

  if (!user) return null;

  return (
    <div className="page">
      <div className="container" style={{ maxWidth: 800 }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 32, marginBottom: 4 }}>
          My profile
        </h1>
        <p className="page-subtitle" style={{ marginBottom: 32 }}>
          Manage your account details and shipping information
        </p>

        <form onSubmit={handleSubmit} className="card">
          <div className="card-header">
            <h2><FaUser style={{ marginRight: 8 }} /> Personal information</h2>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Full name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" name="email" value={formData.email} disabled />
              <small>Email cannot be changed</small>
            </div>
          </div>

          <div className="form-group">
            <label>Phone number</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} />
          </div>

          <div style={{ margin: '32px 0 20px', paddingTop: 24, borderTop: '1px solid var(--gray-100)' }}>
            <h2 style={{ fontSize: 18, display: 'flex', alignItems: 'center', gap: 8 }}>
              <FaMapMarkedAlt /> Default address
            </h2>
          </div>

          <div className="form-group">
            <label>Street address</label>
            <input type="text" name="address.street" value={formData.address.street} onChange={handleChange} />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>City</label>
              <input type="text" name="address.city" value={formData.address.city} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>State / Province</label>
              <input type="text" name="address.state" value={formData.address.state} onChange={handleChange} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>ZIP / Postal code</label>
              <input type="text" name="address.zipCode" value={formData.address.zipCode} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Country</label>
              <input type="text" name="address.country" value={formData.address.country} onChange={handleChange} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving...' : 'Save changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Profile;
